export default __webpack_public_path__ + "static/dr_webglobeanim_web-ea6c559118e585d4b7c077791d2c5b41.gif";